import TabController from "./../factories/tab-controller";
var appTabController = new TabController(true);
export default appTabController;